import React, { Component } from "react";
import commStyles from "../../common/styles";
import { connect } from "react-redux";
import { Container } from "../../common/components/Container";
import { Table } from "../../common/components/Table";
import { Model } from "../../common/components/Model";
import { ReactSelect } from "../../common/components/ReactSelect";
import apiCall from "../../common/utils/apiCall";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "../../common/styles/styles.css";

const {
  Form,
  FormColumn,
  FormRow,
  FormInput,
  FormInputLabel,
  ButtonWrapper,
  ButtonSecondary,
  ButtonSuccess,
  SubHeading,
} = commStyles;

const columns = [
  { id: "badgeName", label: "Badge Title", minWidth: "10%" },
  { id: "createdAt", label: "created on", minWidth: "10%" },
  { id: "updatedAt", label: "updated on", minWidth: "10%" },
  { id: "operationEditDelete", label: "Edit / Delete", minWidth: "10%" },
];
let mountLimit = 1;
let filterHeight = document.getElementById("filterDiv")
  ? `${document.getElementById("filterDiv").offsetHeight}px`
  : "10vh";

class Badge extends Component {
  constructor(props) {
    super(props);
    this.editModel = this.editModel.bind(this);
    this.state = {
      badgeData: [],
      totalSize: 0,
      rowsPerPage: 20,
      filterOptionsLimit: 20,
      deleteModelOpen: false,
      createModelOpen: false,
      editModelOpen: false,
      badgeFilterInput: "",
      badgeCreateInput: "",
      badgeFilterOptions: [],
      badgeCreateOptions: [],
      badgeFilterLoading: false,
      badgeCreateLoading: false,
      filterData: {},
      deleteData: {
        number: "",
      },
      createData: {},
      editData: {},
    };
  }

  async componentDidMount() {
    if (mountLimit == 1) {
      mountLimit++;
      try {
        const { result } = await apiCall("REACT_APP_GET_BADGE", "POST", {
          limit: this.state.rowsPerPage,
          skip: 0,
        });
        if (result && result["success"] && result["status"]) {
          let modifyData = await this.modifyApiData(result.status);
          this.setState({
            badgeData: modifyData,
            totalSize: await result.totalSize,
          });
          toast.success(result.msg);
        }
      } catch (error) {
        console.log("Badge componentDidMount Error ::", error);
      }
      setTimeout(() => {
        mountLimit--;
      }, 500);
    }
  }

  async modifyApiData(rawDataArray) {
    return await rawDataArray.map((data) => {
      data.createdAt = new Date(data.createdAt).toLocaleString();
      data.updatedAt = new Date(data.updatedAt).toLocaleString();
      data["operationDelete"] = data.id;

      return data;
    });
  }
  editModel(data) {
    let editData = this.state.editData;
    editData["id"] = data.id;
    editData["badgeName"] = data.badgeName;
    editData["format"] = data.format;
    this.setState({ editData, editModelOpen: true });
  }
  deleteEntry = (data) => {
    let deleteData = this.state.deleteData;
    deleteData["id"] = data.id;
    this.setState({ deleteData, deleteModelOpen: true });
  };

  formatData = async (data, value, label) => {
    return await data.map((eachData) => {
      let obj = {};
      obj["value"] = eachData[value];
      obj["label"] = eachData[label];
      return obj;
    });
  };

  handleChange = async (event, state, stateEdit, stateCreate) => {
    if (!Array.isArray(event)) {
      event = [event];
    }
    if (stateEdit) {
      let editData = this.state.editData;
      await event.forEach((data) => (editData[stateEdit] = data.value));
      this.setState({ editData });
    } else if (stateCreate) {
      let createData = this.state.createData;
      createData[stateCreate] = "";
      await event.forEach((data) => (createData[stateCreate] = data.value));
      this.setState({ createData });
    } else {
      let filterData = this.state.filterData;
      filterData[state] = [];
      await event.forEach((data) => filterData[state].push(data.value));
      this.setState({ filterData });
      console.log("filterData", filterData);
    }
  };

  handleChangePage = async (chnagedPage, rowsPerPage) => {
    let filterData = this.state.filterData;
    let skippedEmptyArrayOfObj = [];
    Object.keys(filterData).forEach((data) => {
      if (
        filterData[data] == [] ||
        filterData[data] == {} ||
        filterData[data] == ""
      ) {
        delete filterData[data];
      }
    });
    filterData["skip"] = chnagedPage * rowsPerPage || 0;
    filterData["limit"] = rowsPerPage || 20;
    for (let i = 0; i < filterData["skip"]; i++) {
      skippedEmptyArrayOfObj.push({});
    }
    const { result } = await apiCall("REACT_APP_GET_BADGE", "POST", filterData);
    if (result && result["success"] && result["status"]) {
      let modifyData = await this.modifyApiData(result.status);
      this.setState({
        badgeData: [...skippedEmptyArrayOfObj, ...modifyData],
        rowsPerPage: rowsPerPage,
        totalSize: await result.totalSize,
      });
      return true;
    }
    return false;
  };

  handleBadgeInputChange = async (badgeFilterInput, { action }) => {
    this.setState({ badgeFilterLoading: true });
    let input;
    let badgeFilterOptions = [];
    if (action === "set-value") {
      input = this.state.badgeFilterInput;
    } else {
      input = badgeFilterInput;
      this.setState({ badgeFilterInput });
    }
    if (input.split("").length >= 1) {
      const { result } = await apiCall("REACT_APP_GET_BADGE", "POST", {
        textToSearch: input,
        limit: this.state.filterOptionsLimit,
      });
      if (result && result.success) {
        badgeFilterOptions = await this.formatData(
          result.status,
          "id",
          "badgeName"
        );
      }
    }

    this.setState({ badgeFilterOptions, badgeFilterLoading: false });
  };

  submitFilter = async (filterData) => {
    Object.keys(filterData).forEach((data) => {
      if (
        filterData[data] == [] ||
        filterData[data] == {} ||
        filterData[data] == ""
      ) {
        delete filterData[data];
      }
    });
    filterData["skip"] = 0;
    filterData["limit"] = this.state.rowsPerPage || 20;
    const { result } = await apiCall("REACT_APP_GET_BADGE", "POST", filterData);
    if (result && result["success"] && result["status"]) {
      let modifyData = await this.modifyApiData(result.status);
      this.setState({
        categoryData: modifyData,
        totalSize: await result.totalSize,
      });
      toast.success(result.msg);
    }
  };

  submitCreateForm = async (createData) => {
    Object.keys(createData).forEach((data) => {
      if (
        createData[data] == [] ||
        createData[data] == {} ||
        createData[data] == ""
      ) {
        delete createData[data];
      }
    });
    if (Object.keys(createData).length == 0) {
      return;
    }
    const { result } = await apiCall(
      "REACT_APP_CREATE_BADGE",
      "POST",
      createData
    );
    if (result && result["success"] && result["status"]) {
      this.setState({ createModelOpen: false });
      this.submitFilter(this.state.filterData);
      toast.success(result.msg);
    }
  };

  submitEditForm = async (editData) => {
    Object.keys(editData).forEach((data) => {
      if (
        editData[data] == [] ||
        editData[data] == {} ||
        editData[data] == ""
      ) {
        delete editData[data];
      }
    });
    if (Object.keys(editData).length == 0) {
      return;
    }
    const { result } = await apiCall(
      "REACT_APP_UPDATE_BADGE",
      "POST",
      editData
    );
    if (result && result["success"] && result["status"]) {
      this.setState({ editModelOpen: false });
      this.submitFilter(this.state.filterData);
      toast.success(result.msg);
    }
  };

  submitDeleteForm = async (deleteData) => {
    Object.keys(deleteData).forEach((data) => {
      if (
        deleteData[data] == [] ||
        deleteData[data] == {} ||
        deleteData[data] == ""
      ) {
        delete deleteData[data];
      }
    });
    if (Object.keys(deleteData).length == 0) {
      return;
    }
    const { result } = await apiCall(
      "REACT_APP_DELETE_BADGE",
      "POST",
      deleteData
    );
    if (result && result["success"] && result["status"]) {
      this.setState({ deleteModelOpen: false });
      this.submitFilter(this.state.filterData);
      toast.success(result.msg);
    }
  };

  render() {
    console.log("[Badge.jsx]::this.state::", typeof this.state, this.state);
    console.log("[Badge.jsx]::this.props::", typeof this.props, this.state);
    return (
      <React.Fragment>
        <Container headerName="Badge Manager" navPosition="6">
          <div
            id="filterDiv"
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              height: filterHeight,
              border: "none",
              overflow: "none",
            }}
          >
            <div id="filterSelectDiv1">
              <ReactSelect
                label={"Numbers Badge"}
                placeholder={"Search Badge"}
                inputValue={this.state.badgeFilterInput}
                onInputChange={this.handleBadgeInputChange}
                options={this.state.badgeFilterOptions}
                stateFilterName={"id"}
                onChange={this.handleChange}
                isLoading={this.state.badgeFilterLoading}
                isMulti={true}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ButtonSuccess
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "5px",
                  alignItems: "center",
                  height: "28px",
                  padding: "7px 10px",
                }}
                onClick={() => {
                  this.submitFilter(this.state.filterData);
                }}
              >
                <span id="filterButtonStyle">FILTER</span>
                <FilterAltIcon sx={{ width: "15px" }} />
              </ButtonSuccess>
              <ButtonSuccess
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "5px",
                  alignItems: "center",
                  height: "28px",
                  padding: "7px 10px",
                }}
                onClick={() => {
                  this.setState({ createModelOpen: true });
                }}
              >
                <span id="filterButtonStyle">CREATE</span>
                <AddCircleIcon sx={{ width: "15px" }} />
              </ButtonSuccess>
            </div>
          </div>
          {console.log(this.state.badgeData)}
          <Table
            columns={columns || []}
            dataValues={this.state.badgeData || []}
            totalSize={this.state.totalSize || 0}
            filterHeight={filterHeight}
            rowsPerPage={this.state.rowsPerPage}
            handleChangePage={this.handleChangePage}
            editModel={this.editModel}
            deleteEntry={this.deleteEntry}
          />
        </Container>

        {/* DELETE MODEL */}
        <Model title={"Delete Badge"} modelOpen={this.state.deleteModelOpen}>
          <Form>
            <SubHeading>
              Are you sure, do you want to delete badge data ?
            </SubHeading>
            <ButtonWrapper>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/badge"}
              >
                <ButtonSecondary
                  onClick={() => {
                    this.setState({ deleteModelOpen: false });
                  }}
                >
                  Cancel
                </ButtonSecondary>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/badge"}
              >
                <ButtonSuccess
                  style={{
                    marginLeft: "10px",
                    textDecoration: "none",
                  }}
                  onClick={() => {
                    this.submitDeleteForm(this.state.deleteData);
                  }}
                >
                  Submit
                </ButtonSuccess>
              </Link>
            </ButtonWrapper>
          </Form>
        </Model>

        {/* CREATE MODEL */}
        <Model
          title={"Create Badge"}
          modelOpen={this.state.createModelOpen}
          width={"400px"}
        >
          <Form>
            <FormRow>
              <FormColumn>
                <FormInputLabel>Badge Title</FormInputLabel>
                <FormInput
                  type="text"
                  required={true}
                  value={this.state.createData.badgeName}
                  placeholder="Badge Title"
                  onChange={(e) => {
                    this.handleChange(e.target, "", "", "badgeName");
                  }}
                ></FormInput>
              </FormColumn>
            </FormRow>
            <ButtonWrapper>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/badge"}
              >
                <ButtonSecondary
                  onClick={() => {
                    this.setState({ createModelOpen: false });
                  }}
                >
                  Cancel
                </ButtonSecondary>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/badge"}
              >
                <ButtonSuccess
                  style={{
                    marginLeft: "10px",
                    textDecoration: "none",
                  }}
                  onClick={() => {
                    this.submitCreateForm(this.state.createData);
                  }}
                >
                  Submit
                </ButtonSuccess>
              </Link>
            </ButtonWrapper>
          </Form>
        </Model>

        {/* EDIT MODEL */}
        <Model title={"Edit Badge"} modelOpen={this.state.editModelOpen}>
          <Form>
            <FormRow>
              <FormColumn>
                <FormInputLabel>Badge Title</FormInputLabel>
                <FormInput
                  type="text"
                  required={true}
                  value={
                    this.state.editData ? this.state.editData.badgeName : ""
                  }
                  placeholder="Badge Title"
                  onChange={(e) => {
                    this.handleChange(e.target, "", "badgeName");
                  }}
                ></FormInput>
              </FormColumn>
            </FormRow>
            <ButtonWrapper>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/badge"}
              >
                <ButtonSecondary
                  onClick={() => {
                    this.setState({ editModelOpen: false });
                  }}
                >
                  Cancel
                </ButtonSecondary>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/badge"}
              >
                <ButtonSuccess
                  style={{
                    marginLeft: "10px",
                    textDecoration: "none",
                  }}
                  onClick={() => {
                    this.submitEditForm(this.state.editData);
                  }}
                >
                  Submit
                </ButtonSuccess>
              </Link>
            </ButtonWrapper>
          </Form>
        </Model>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Badge);
